class FadeInOnScroll {
  constructor(selector, options = {}) {
    this.elements = document.querySelectorAll(selector);
    this.options = Object.assign(
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.2, // Trigger when 20% of the element is visible
        animationClass: "fade-in-visible",
      },
      options
    );

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), this.options);
    this.init();
  }

  init() {
    this.elements.forEach((el) => {
      el.classList.add("fade-in"); // Add initial hidden class
      this.observer.observe(el);
    });
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(this.options.animationClass);
        this.observer.unobserve(entry.target); // Stop observing once it's visible
      }
    });
  }
}

// Initialize the effect
document.addEventListener("DOMContentLoaded", () => {
  new FadeInOnScroll(".fade-in-element");
});
